import { memo } from "react";

import { cn } from "@/lib/utils/cn";

export interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const Select = memo(function Select({
  value,
  onChange,
  options,
  placeholder = "Select…",
  disabled,
  className,
}: SelectProps) {
  return (
    <select
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        "h-9 w-full appearance-none rounded-md border border-neutral-200 bg-white px-3 font-sans text-sm text-neutral-800 outline-none transition-colors duration-150",
        "focus:border-primary-500 focus:ring-[3px] focus:ring-primary-100",
        "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:opacity-50",
        "dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100",
        className,
      )}
    >
      <option value="" disabled hidden>
        {placeholder}
      </option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
});

export default Select;
